import styles from './style.module.scss';

interface Props {
    className?: string;
}

function Loading(props: Props) {
    const { className } = props;

    return (
        <div className={`${styles.container} ${className || ''}`}>
            <div className={styles.breeding_rhombus_spinner}>
                <div className={`${styles.rhombus} ${styles.child_1}`}></div>
                <div className={`${styles.rhombus} ${styles.child_2}`}></div>
                <div className={`${styles.rhombus} ${styles.child_3}`}></div>
                <div className={`${styles.rhombus} ${styles.child_4}`}></div>
                <div className={`${styles.rhombus} ${styles.child_5}`}></div>
                <div className={`${styles.rhombus} ${styles.child_6}`}></div>
                <div className={`${styles.rhombus} ${styles.child_7}`}></div>
                <div className={`${styles.rhombus} ${styles.child_8}`}></div>
                <div className={`${styles.rhombus} ${styles.big}`}></div>
            </div>
        </div>
    )
};

export default Loading;
